import { render } from "./Identificacao.vue?vue&type=template&id=d4d88fea&scoped=true&ts=true"
import script from "./Identificacao.vue?vue&type=script&lang=ts"
export * from "./Identificacao.vue?vue&type=script&lang=ts"

import "./Identificacao.vue?vue&type=style&index=0&id=d4d88fea&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4d88fea"]])

export default __exports__